// Local game-history persistence (same localStorage approach as sudoku-ml).

const HISTORY_KEY = 'card-sharks-game-history'

export const loadHistory = () => {
  try {
    return JSON.parse(window.localStorage.getItem(HISTORY_KEY)) || []
  } catch (e) {
    return []
  }
}

export const saveHistory = list => {
  try {
    window.localStorage.setItem(HISTORY_KEY, JSON.stringify(list))
  } catch (e) {}
}
